import { render, staticRenderFns } from "./LSVCompactNew.vue?vue&type=template&id=24e994b8&scoped=true"
import script from "./LSVCompactNew.vue?vue&type=script&lang=js"
export * from "./LSVCompactNew.vue?vue&type=script&lang=js"
import style0 from "./LSVCompactNew.vue?vue&type=style&index=0&id=24e994b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e994b8",
  null
  
)

export default component.exports